import { gql, TypedDocumentNode } from "@apollo/client";

import { QuerySearchSpaceliftVcSesArgs, SearchSpaceliftVcSesOutput } from "types/generated";

import { SPACELIFT_VCS_REPO_BASIC_FRAGMENT } from "../gql";

export const SEARCH_SPACELIFT_VCS_REPOS: TypedDocumentNode<
  { searchSpaceliftVCSes: SearchSpaceliftVcSesOutput },
  QuerySearchSpaceliftVcSesArgs
> = gql`
  query SearchSpaceliftVcsRepos($input: SearchInput!) {
    searchSpaceliftVCSes(input: $input) {
      edges {
        cursor
        node {
          ...SpaceliftVcsRepoBasic
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
  ${SPACELIFT_VCS_REPO_BASIC_FRAGMENT}
`;
